<div *ngIf="isAllowed">
  <mat-card class="header" [ngClass]="dealerImageDetails?.url ? 'header-with-image':'header-without-image'">
  <div class="header-image">
    @if (dealerImageDetails?.url) {
      <img [src]=[dealerImageDetails?.url] alt="File not found." i18n-alt />
    }
  </div>
  <div class="header-text">
    <div class="basic-info">
      @if (reportResponse?.name) {
        <div class="request-text">{{reportResponse.name}}</div>
      }
      <div class="date-time">{{formatedDateTime}}</div>
    </div>
    @if (reportResponse?.order?.customer) {
      <div class="user-info">
        <div class="user-name">{{reportResponse.order?.customer?.name}}</div>
        <div class="vehicle-model"> {{reportResponse.order?.vehicle?.model}} {{reportResponse.order?.vehicle?.make}}
        </div>
        <div class="vehicle-no"> {{reportResponse.order?.vehicle?.licenseNo}} </div>
      </div>
    }
  </div>
  @if (reportResponse) {
    <div class="pdf-container">
      <button [disabled]="!isPDFDataAvailable" matTooltip="Download PDF" i18n-matTooltip (click)="downloadPDF()"
        class="button-pdf" mat-mini-fab color="primary">
        <img class="download-icon" class="button-pdf" src="../../assets/common/download.svg"
          alt="File not found." i18n-alt>
        </button>
      </div>
    }
  </mat-card>

  @if (reportResponse?.categories) {
    <div>
      @for (categoryWithCheckpoints of reportResponse.categories; track categoryWithCheckpoints) {
        <div>
          @for (checkpoint of categoryWithCheckpoints.checkpoints; track checkpoint) {
            <div>
              @if (checkpoint.isWalkthroughEnabled) {
                <app-vvr-vehicle-walkthrough></app-vvr-vehicle-walkthrough>
              }
            </div>
          }
        </div>
      }
    </div>
  }


  <div class="body-container small-block">
    @for (category of reportResponse?.categories; track category; let k = $index) {
      <div class="checklist-container">
        @if (isCheckpointDisabled(category)) {
          <div class="checklist-header">
            {{category?.name}}
          </div>
        }
        <div class="checklist-body">
          @for (checkpoint of category?.checkpoints; track checkpoint; let j = $index) {
            <div class="checklist-accordion">
              @if (!checkpoint.isWalkthroughEnabled) {
                <mat-accordion >
                  <mat-expansion-panel class="expansion-panel"
          [expanded]="((checkpoint?.findings?.length ?? 0 > 0) || checkpoint.solution
          || checkpoint.measuredValues?.[0]?.value || (checkpoint.measuredValues?.[0]?.media?.length ?? 0 > 0) || (checkpoint?.media?.length?? 0 > 0))"
          [disabled]="!((checkpoint?.findings?.length ?? 0 > 0) || checkpoint.solution
          || checkpoint.measuredValues?.[0]?.value || (checkpoint.measuredValues?.[0]?.media?.length ?? 0 > 0) || (checkpoint?.media?.length?? 0 > 0))">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="radio-button">
                  @if (checkpoint.status === 'NotOKRed') {
<img src="../../assets/common/radio-buttons/not-ok-red.svg"
                    alt="File not found." i18n-alt>
                          }
                          @if (checkpoint.status === 'NotOK') {
                            <img src="../../assets/common/radio-buttons/not-ok.svg"
                              alt="File not found." i18n-alt>
                          }
                          @if (checkpoint.status === 'OK') {
                            <img src="../../assets/common/radio-buttons/ok.svg"
                              alt="File not found." i18n-alt>
                          }
                          @if (checkpoint.status === 'Undefined') {
                            <img src="../../assets/common/radio-buttons/Undefined.svg"
                              alt="File not found." i18n-alt>
                          }
                        </div>
                        <div class="checkpoint-title">
                          {{checkpoint.description}}
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="expansion-panel-body">
                      <div class="checkpoint-description">
                        {{checkpoint.solution?.description}}
                      </div>
                      <div class="checkpoint-measuredValue">
                        {{checkpoint.measuredValues?.[0]?.value}}
                      </div>
                      @if (checkpoint.comment) {
                        <div class="checkpoint-measuredValue">
                          {{checkpoint.comment}}
                        </div>
                      }
                      @if (checkpoint?.media?.length?? 0 > 0) {
                        <div class="carousel-container">
                          <app-carousel id="{{j}}{{k}}" [media]="checkpoint.media" [isWalkthroughEnabled]="checkpoint.isWalkthroughEnabled" [introOutroMediaData]="introOutroMediaData"></app-carousel>
                        </div>
                      }
                      @if (checkpoint.measuredValues && checkpoint.measuredValues[0]?.media) {
                        <div class="carousel-container">
                          <app-carousel id="{{j}}{{k}}" [media]="checkpoint.measuredValues[0].media" [isWalkthroughEnabled]="checkpoint.isWalkthroughEnabled" [introOutroMediaData]="introOutroMediaData"></app-carousel>
                        </div>
                      }
                      @for (findings of checkpoint?.findings; track findings; let l = $index) {
                        <div class="findings-container">
                          <div class="finding-description">
                            {{findings.findingType?.description}}
                          </div>
                          <div class="finding-solution">
                            {{findings.solution?.description}}
                          </div>
                          <div class="finding-comment">
                            {{findings.comment}}
                          </div>
                          @if (findings.media && findings.media.length > 0) {
                            <div class="carousel-container">
                              <app-carousel id="{{j}}{{k}}{{l}}" [media]="findings?.media" [isWalkthroughEnabled]="checkpoint.isWalkthroughEnabled" [introOutroMediaData]="introOutroMediaData"></app-carousel>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>

  <div class="body-container largeblock" #bodyContainer>
    @if (reportResponse?.categories) {
      <div class="goto-top" (click)="scrollToElement('0')">
        <img class="goto-top-icon" src="../../assets/common/arrows/up-arrow.svg"
          alt="File not found." i18n-alt>
        </div>
      }
      <div class="category-list">
        <div class="category-list-items">
          @if (reportResponse?.categories) {
            <div class="category-text" i18n>Category</div>
          }
          @for (category of reportResponse?.categories; track category; let k = $index) {
            <a (click)="selectedCategoryIndex = k"
              [ngClass]="{'clicked': selectedCategoryIndex === k}" (click)="scrollToElement(k+'')">
              @if (isCheckpointDisabled(category)) {
                <div>
                  {{ category.name }}
                </div>
              }
            </a>
          }
        </div>
      </div>
      <div class="checklist-data-large">
        @if (selectedCategory || true;) {
          <div>
            <div class="checklist-body">
              @for (category of reportResponse?.categories; track category; let k = $index) {
                <div class="checklist-item">
                  <div class="checklist-header" [attr.id]="k">
                    @if (isCheckpointDisabled(category)) {
                      <div>
                        {{category.name}}
                      </div>
                    }
                  </div>
                  <div class="checklist-body">
                    @for (checkpoint of category?.checkpoints; track checkpoint; let j = $index) {
                      <div class="checklist-accordion">
                        @if (!checkpoint.isWalkthroughEnabled) {
                          <mat-accordion>
                <mat-expansion-panel [expanded]="((checkpoint?.findings?.length ?? 0 > 0) || checkpoint.solution
                  || checkpoint.measuredValues?.[0]?.value || (checkpoint.measuredValues?.[0]?.media?.length ?? 0 > 0) || (checkpoint?.media?.length?? 0 > 0))"
                  [disabled]="!((checkpoint?.findings?.length ?? 0 > 0) || checkpoint.solution
                  || checkpoint.measuredValues?.[0]?.value || (checkpoint.measuredValues?.[0]?.media?.length ?? 0 > 0) || (checkpoint?.media?.length?? 0 > 0))">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <div class="radio-button">
                        @if (checkpoint.status === 'NotOKRed') {
<img src="../../assets/common/radio-buttons/not-ok-red.svg"
                    alt="File not found." i18n-alt>
                                    }
                                    @if (checkpoint.status === 'NotOK') {
                                      <img src="../../assets/common/radio-buttons/not-ok.svg"
                                        alt="File not found." i18n-alt>
                                    }
                                    @if (checkpoint.status === 'OK') {
                                      <img src="../../assets/common/radio-buttons/ok.svg"
                                        alt="File not found." i18n-alt>
                                    }
                                    @if (checkpoint.status === 'Undefined') {
                                      <img
                                        src="../../assets/common/radio-buttons/Undefined.svg"
                                        alt="File not found." i18n-alt>
                                    }
                                  </div>
                                  <div class="checkpoint-title">
                                    {{checkpoint.description}}
                                  </div>
                                </mat-panel-title>
                              </mat-expansion-panel-header>
                              <div class="expansion-panel-body">
                                <div class="checkpoint-description">
                                  {{checkpoint.solution?.description}}
                                </div>
                                <div class="checkpoint-measuredValue">
                                  {{checkpoint.measuredValues?.[0]?.value}}
                                </div>
                                @if (checkpoint.comment) {
                                  <div class="checkpoint-measuredValue">
                                    {{checkpoint.comment}}
                                  </div>
                                }
                                @if (checkpoint && checkpoint.measuredValues && checkpoint.measuredValues[0] &&
                                  checkpoint.measuredValues[0].media && checkpoint.measuredValues[0].media.length > 0 || (checkpoint?.media)) {
                                  <p class="gallery" i18n>Gallery</p>
                                }
                                @if (checkpoint?.media) {
                                  <div class="media-list">
                                    @for (item of checkpoint?.media; track item; let j = $index) {
                                      <div [class.active]="j === 0">
                                        @if (item.mimeType.includes('video')) {
                                          <div class="large-screen-media-image">
                                            <mat-icon (click)="closeMediaModal(checkpoint.media, j, checkpoint.isWalkthroughEnabled)"
                                            class="mat-play-icon">play_arrow</mat-icon>
                                            <a (click)="closeMediaModal(checkpoint.media, j, checkpoint.isWalkthroughEnabled)">
                                              <img [src]="item.thumbnail?.url" alt="File not found." i18n-alt>
                                            </a>
                                          </div>
                                        }
                                        @if (item.mimeType.includes('Image')) {
                                          <div class="large-screen-media-image">
                                            <a (click)="closeMediaModal(checkpoint.media, j, checkpoint.isWalkthroughEnabled)">
                                              <img [src]="item.url" alt="File not found." i18n-alt>
                                            </a>
                                          </div>
                                        }
                                      </div>
                                    }
                                  </div>
                                }
                                @if (checkpoint?.measuredValues?.[0]?.media) {
                                  <div class="media-list">
                                    @for (item of checkpoint.measuredValues?.[0]?.media; track item; let j = $index) {
                                      <div [class.active]="j === 0">
                                        @if (item.mimeType.includes('video')) {
                                          <div class="large-screen-media-image">
                                            <mat-icon (click)="closeMediaModal(checkpoint.measuredValues?.[0]?.media, j, checkpoint.isWalkthroughEnabled)"
                                            class="mat-play-icon">play_arrow</mat-icon>
                                            <a (click)="closeMediaModal(checkpoint.measuredValues?.[0]?.media, j, checkpoint.isWalkthroughEnabled)">
                                              <img [src]="item.thumbnail?.url" alt="File not found." i18n-alt>
                                            </a>
                                          </div>
                                        }
                                        @if (item.mimeType.includes('Image')) {
                                          <div class="large-screen-media-image">
                                            <a (click)="closeMediaModal(checkpoint.measuredValues?.[0]?.media, j, checkpoint.isWalkthroughEnabled)">
                                              <img [src]="item.url" alt="File not found." i18n-alt>
                                            </a>
                                          </div>
                                        }
                                      </div>
                                    }
                                  </div>
                                }
                                @if (checkpoint.findings) {
                                  <div>
                                    @for (findings of checkpoint.findings; track findings) {
                                      <div>
                                        <div class="description">
                                          {{findings.findingType?.description}}
                                        </div>
                                        <div>
                                          {{findings.solution?.description}}
                                        </div>
                                        <div class="comment">
                                          {{findings.comment}}
                                        </div>
                                        @if (findings.media && findings.media.length>0) {
                                          <p class="gallery" i18n>Gallery</p>
                                        }
                                        @if (findings.media) {
                                          <div class="media-list">
                                            @for (item of findings?.media; track item; let j = $index) {
                                              <div [class.active]="j === 0">
                                                @if (item.mimeType.includes('video')) {
                                                  <div class="large-screen-media-image">
                                                    <mat-icon (click)="closeMediaModal(findings.media, j, checkpoint.isWalkthroughEnabled)"
                                                    class="mat-play-icon">play_arrow</mat-icon>
                                                    <a (click)="closeMediaModal(findings.media, j, checkpoint.isWalkthroughEnabled)">
                                                      <img [src]="item.thumbnail?.url" alt="File not found." i18n-alt>
                                                    </a>
                                                  </div>
                                                }
                                                @if (item.mimeType.includes('Image')) {
                                                  <div class="large-screen-media-image">
                                                    <a (click)="closeMediaModal(findings.media, j, checkpoint.isWalkthroughEnabled)">
                                                      <img [src]="item.url" alt="File not found." i18n-alt>
                                                    </a>
                                                  </div>
                                                }
                                              </div>
                                            }
                                          </div>
                                        }
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            </mat-expansion-panel>
                          </mat-accordion>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>

    <div class="backdrop"></div>
    <div class="modal" #imageModal tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title"></div>
            <button (click)="closeModal()" type="button" class="close">
              <span>&times;</span>
            </button>
          </div>
          <div class="model-media-container">
            <div class="navigation-button">
              <mat-icon class="navigation-left"
              (click)="closeMediaModal(modelMedia, currentSelectedModel-1)">keyboard_arrow_left</mat-icon>
            </div>
            <div class="modal-body">
              @if (mediaElememt === 'image') {
                <img [src]="modalImageUrl" class="d-block w-100" alt="modalImage">
              }
              @if (mediaElememt === 'video' && !(isWalkthroughEnabled && !isObjectEmpty(introOutroMediaData))) {
                <video id="model-video" #modelVideo autoplay controls>
                  <source [src]="modalImageUrl" type="video/mp4">
                  <source [src]="modalImageUrl" type="video/ogg">
                  Your browser does not support the video.
                </video>
              }
              @if (mediaElememt === 'video' && (isWalkthroughEnabled && !isObjectEmpty(introOutroMediaData))) {
                <div class="video-player-large-div">
                  @for (media of modelMedia; track media; let i = $index) {
                    <div class="video-player-large-child-div">
                      @if (i==currentSelectedModel) {
                        <app-video-player [media]="modelMedia[i]" [introOutroMediaData]="introOutroMediaData"></app-video-player>
                      }
                    </div>
                  }
                </div>
              }
            </div>
            <div class="navigation-button">
              <mat-icon class="navigation-right"
              (click)="closeMediaModal(modelMedia, currentSelectedModel+1)">keyboard_arrow_right</mat-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>

<div *ngIf="!isAllowed"></div>